<div class="m-4 flex flex-col gap-2 w-full">
    <div class="flex flex-wrap gap-5">
        <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
            <p class="text-neutral-1200">{{ 'shared.labels.electricity.supplier' | transloco }}</p>
            <p class="text-black font-semibold text-xl mobile:text-lg">
                {{ 'shared.not_available' | transloco }}</p>
        </div>
        <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
            <p class="text-neutral-1200">{{ 'shared.labels.electricity.vat' | transloco }}</p>
            <p class="text-black font-semibold text-xl mobile:text-lg">
                {{ vat || ('shared.not_available' | transloco) }}</p>
        </div>
    </div>
    <div class="flex flex-wrap gap-5">
        <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
            <p class="text-neutral-1200">{{ 'shared.labels.electricity.pod_id' | transloco }}</p>
            <p class="text-black font-semibold text-xl mobile:text-lg">
                {{ 'shared.not_available' | transloco }}</p>
        </div>
        <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
            <p class="text-neutral-1200">{{ 'shared.labels.electricity.start_of_supply' | transloco }}</p>
            <p class="text-black font-semibold text-xl mobile:text-lg">{{ 'shared.not_available' | transloco }}
            </p>
        </div>
    </div>
    <div class="flex flex-wrap gap-5">
        <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
            <p class="text-neutral-1200">{{ 'locations.available_capacity' | transloco }}
            </p>
            <p class="text-black font-semibold text-xl mobile:text-lg">{{ 'shared.not_available' | transloco }} kW</p>
        </div>
        <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
            <p class="text-neutral-1200">{{ 'shared.labels.electricity.end_of_supply' | transloco }}</p>
            <p class="text-black font-semibold text-xl mobile:text-lg">
                {{ 'shared.not_available' | transloco }}</p>
        </div>
    </div>
    <div class="flex flex-wrap gap-5">
        <div class="flex-[1] min-w-[200px] min-h-[50px] flex flex-col gap-1">
            <p class="text-neutral-1200">{{ 'shared.labels.electricity.tension' | transloco }}</p>
            <p class="text-black font-semibold text-xl mobile:text-lg">
                {{ 'shared.not_available' | transloco }}</p>
        </div>
    </div>
</div>